import { ChevronRightIcon } from "@chakra-ui/icons";
import { Button, HStack, Avatar, Stack, Text, Box } from "@chakra-ui/react";
import useCoinInfo from "hooks/useCoinInfo";

export default function StakeInfo(props) {
  const {
    coin,
    title,
    subtitle,
    onClick,
    _title,
    _subtitle,
    _child,
    children,
    ...xprops
  } = props;

  const { image } = useCoinInfo(coin);

  return (
    <Button
      d="flex"
      bg="white"
      flexDir="row"
      variant="unstyled"
      minW="100%"
      maxH="fit-content"
      maxW="fit-content"
      borderRadius="16px"
      border="1px solid transparent"
      borderColor="#EFF0F6"
      rightIcon={<Box fontSize="3xl" as={ChevronRightIcon} />}
      justifyContent="space-between"
      p="20px"
      h="fit-content"
      pos="relative"
      _focus={{
        borderColor: "var(--primary)",
        shadow: "0 0 0 3px var(--focusColor)",
      }}
      onClick={onClick}
      {...xprops}
    >
      <HStack>
        {image && (
          <Avatar size="md" src={image} objectFit="cover" bg="transparent" />
        )}
        <Stack alignItems="flex-start">
          <Text fontSize="18" fontWeight="600" color="#14142B" {..._title}>
            {title}
          </Text>
          {subtitle && (
            <Text
              mt="0 !important"
              fontSize="16px"
              fontWeight="400"
              color="#6E7191"
              {..._subtitle}
            >
              {subtitle}
            </Text>
          )}
        </Stack>
      </HStack>

      {children && (
        <Box pos="absolute" {..._child}>
          {children}
        </Box>
      )}
    </Button>
  );
}
